import { Storage } from '@lightningjs/sdk';
import { getProfile } from '../../../../api/profiles';

//Components
import ProfileName from '../components/ProfileName';
import ProfilePicture from '../components/ProfilePicture';
import Language from '../components/Language';
import AutoPlay from '../components/AutoPlay';

let profileInfo;

export default function (page, { profileId }) {
  profileInfo = Storage.get(profileId);
  return getProfile(profileId).then(({ data }) => {
    Storage.set(profileId, {
      profileImage: data.avatar_image_url,
      profileName: data.first_name,
      profileLanguage: data.native_language,
      profileAutoplay: data.autoplay,
      profileAvatarId: data.avatar_id,
    });
    const profileName = [
      {
        collision: true,
        type: ProfileName,
        name: data.first_name,
        profileId: profileId,
      },
    ];

    const profilePicture = [
      {
        collision: true,
        type: ProfilePicture,
        profileId: profileId,
      },
    ];

    const profileLanguage = [
      {
        collision: true,
        type: Language,
        lng: data.native_language,
        profileId: profileId,
      },
    ];

    const profileAutoplay = [
      {
        collision: true,
        type: AutoPlay,
        profileId: profileId,
      },
    ];

    page._ProfileName.items = profileName;
    page._Picture.items = profilePicture;
    page._Language.items = profileLanguage;
    page._Autoplay.items = profileAutoplay;
  });
}
